// iOS Safari Private Mode 및 스토리지 제한 상황에서 localStorage
// 접근이 throw할 때 앱이 죽지 않도록 가드하는 공용 래퍼.
// 실패 시 get은 null 반환, set은 false 반환, remove는 silent fail.

export const storage = {
  get: (key: string): string | null => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set: (key: string, value: string): boolean => {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch {
      return false;
    }
  },
  remove: (key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch {
      // silent fail
    }
  },
};
